import { kebabCase } from 'lodash';
import pluralize from 'pluralize';

export function getInferredUri(ModelClass: object): string {
  const modelName = (typeof ModelClass === 'function' && ModelClass.prototype !== undefined)
    ? ModelClass.name
    : ModelClass.constructor.name;
  const kebabCaseName = kebabCase(modelName);
  const segments = kebabCaseName.split('-');

  if (segments.length > 1) {
    const lastSegment = segments.pop() as string;
    const pluralized = pluralize(lastSegment);

    return segments
      .concat(pluralized)
      .join('-');
  }

  return pluralize(kebabCaseName);
}
